import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useHistory, Link, useLocation,useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import DataTable from 'react-data-table-component';
import { contentContext } from "../../context/contentContext";
// import TableLoader from "../../components/tableLoader";
import Loader from "../../components/loader";
const ViewResult = () => {
    let { id } = useParams();
    const history = useHistory();
    const { state } = useLocation();

    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)

    const { quizResult, quizinfo, formData } = state || {};

    const [selected, setSelected] = useState({});
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(false);
    const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState(null);
    const [items, setItems] = useState([]);
    const [success, setSuccess] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(true);
    const [quizzes, setQuizzes] = useState([]);
    const [quizResultData, setQuizResultData] = useState({});
console.log("Dateeeeeeeeeeeeeee",id)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    useEffect(() => {
        if (!localStorage.getItem("token1")) {
            history.push("/login");
        }
    }, [])
    // useEffect(() => {

    //     // Add event listener for popstate to detect when the user presses the back button
    //     const handlePopState = (event) => {

    //         history.push("/")
    //         event.preventDefault();
    //         console.log("Browser back button pressed.");

    //     };

    //     // Initially pushState to allow popstate to fire
    //     window.history.pushState({}, document.title, window.location.href);

    //     // Add popstate listener
    //     window.addEventListener("popstate", handlePopState);

    //     return () => {
    //         // Cleanup event listener when component unmounts
    //         window.removeEventListener("popstate", handlePopState);
    //     };


    // }, []);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
   

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };


    const columns = [
        // {
        //     name: 'Sl NO',
        //     selector: (row, index) => index + 1
        // },
        {
            name: 'TITLE',
            selector: row => {
                console.log("Title row data:", row); // Log the row data for TITLE
                return parse(row?.description) ?? "";
            },
        },
        {
            name: 'QUESTION',
            selector: row => row?.question ?? "",

        },
        {
            name: 'USER ANSWER',
            cell: (props) =>
                <div>
                    <span className={props?.actualanswer == props?.answer ? "correct" : "wrong error"}>{props?.answer}</span>
                </div>
            ,

        },
        {
            name: 'ACTUAL ANSWER',
            cell: (props) =>
                <div>
                    <span>{props?.actualanswer}</span>
                </div>
            ,

        },

    ];


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);



    useEffect(() => {
         window.scrollTo(0, 0);
        let quizinfo = JSON.parse(localStorage.getItem('q'))
        if (quizinfo) {
            setQuizData(quizinfo)
        }
        // let quizResult = JSON.parse(localStorage.getItem('qr'))
        // console.log('quizResult', quizResult)
        // if (quizResult) {
        //     setQuizResultData(quizResult)
        //     setQuizzes(quizResult?.quiz)
        // }
       
    }, []);
    useEffect(() => {
      
       viewResult()
   }, []);

    const viewResult = async () => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.viewResult1(id);
            setQuizzes(response?.result?.[0]);
            setcontentLoaded(true)
            setIsLoading(false);
            setQuizResultData(response?.result?.[0]?.quiz)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };

  
    // useEffect(() => {
    //     if (quizData) {
    //         GetQuestionsInfo(quizData)
    //         GetAnswersInfo()
    //     }

    // }, [quizData]);

    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };

    const handleBack=()=>{
        history.goBack()
    }



    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }
    const handleReports = (id) => {
        history.push("/viewreports/"+id);
    }
    console.log("Quizzes data:", quizzes?.quiz);

    return (
        <main>
            <Header />
          
            <div className="wrapper quiz_page result">
            {isLoading?<Loader/>:
            <>
             <div className="form_block">
                  

                  <div className="quiz_info">
                      <div className="d-flex align-items-center">
                          <div className="img">
                              {quizzes?.files && quizzes?.files.length > 0 ?
                                  <img src={imageCloudfront + quizzes?.files[0]?.filepath.replace(/ /g, "%20")+`?auto=compress,format&width=125`} />
                                  : <img src={quizThumb+`?auto=compress,format&width=125`} />}
                          </div>
                          <div>
                              <h3>{quizzes?.quizname}</h3>
                              <div className="date">
                                  <p>{quizzes?.startDate && moment(new Date(quizzes?.startDate)).format('DD MMM, YYYY')}</p>
                                
                                  

                                  <span className="users"><span className="material-symbols-outlined icon"> group </span><span className="num">{quizzes?.participants}</span></span>
                              </div>

                          </div>
                      </div>
                      <div className="score">
                          <p>Score:</p>
                          <div className="score_count">
                              <p>{quizzes?.correctAnswers}/{quizzes?.totalQuestions}</p>
                          </div>
                      </div>
                      <div className="d-flex align-items-center">
                          <button className=" border_btn fill_btn" onClick={()=>handleReports(quizzes?.quizid)}>Summary </button>

                          <a className=" border_btn" onClick={handleBack}> <span class="material-symbols-outlined mr-10"> arrow_back </span> Back </a>
                      </div>
                  </div>

              </div>
              <div className="question_block">

                  {contentLoaded && quizResultData && quizResultData.length > 0 &&
                      <DataTable
                      key={keyForRerender} // Key to force re-render
                      columns={columns} // Column definitions
                      className="table-responsive result_table" // Add custom class
                      keyField="questionid" // Unique key for each row
                      data={quizResultData} // Safely pass data (default to empty array if undefined)
                      direction="auto" // Auto direction for layout
                      highlightOnHover // Highlight rows on hover
                      fixedHeaderScrollHeight="300px" // Fix table height
                      responsive // Enable responsive table
                      persistTableHead // Persist table headers
                      striped // Enable striped rows
                      defaultSortField="name" // Default sorting column
                      onChangeRowsPerPage={handlePerRowsChange} // Handle rows per page change
                      onChangePage={handlePageChange} // Handle page change
                     
                     
                  />
                  
                  }

                  {contentLoaded && quizzes && quizzes.length == 0 &&
                      customNoRecords()
                  }

                  {/* <div className="table-responsive ">
                      <table className="table db_table">

                          <thead className="table-light">
                              <tr>
                                  <th width="5%">s no</th>
                                  <th width="35%">scenario</th>
                                  <th width="30%">question</th>
                                  <th width="15%">Selected Answer</th>
                                  <th width="15%">answer</th>

                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>1</td>
                                  <td>Verocay bodies are a component of schwannomas and are usually identified in them, but they can also be seen in other neoplasms:</td>
                                  <td> <h4>Verocay bodies are seen in?</h4> </td>
                                  <td><span className="correct">abscess</span></td>
                                  <td>abscess</td>

                              </tr>
                              <tr>
                                  <td>2</td>
                                  <td>Title: Erythematous papule Definition: A circumscribed, solid elevation of skin with no visible fluid that is reddish (erythematous) in color.</td>
                                  <td> <h4>A 24 year old man comes with complaint of recurrent eruption on face for 6 years. On examination, there are erythematous papules and nodules involving the forehead, cheeks, nose, eyelids and ear rim. Interspersed are numerous deep pitted scars. You have decided to go ahead with a skin biopsy. What do you expect to find?</h4> </td>
                                  <td> <span className="wrong">acantholytic dermatitis herpetiformis (pemphigus herpetiformis)</span> </td>
                                  <td>acantholytic dyskeratoma</td>

                              </tr>
                              <tr>
                                  <td>3</td>
                                  <td>The promontory sign is a characteristic appearance of new blood vessels wrapping around and partially entraping pre-existing blood vessels, causing the pre-existing vessels to protrude into the lumen of the new vessels. It can be seen in the following conditions:</td>
                                  <td> <h4>Promontory sign is seen in?</h4> </td>
                                  <td> <span className="correct">acantholytic dyskeratoma</span></td>
                                  <td>acantholytic EB, lethal</td>

                              </tr>
                              <tr>
                                  <td>4</td>
                                  <td>Verocay bodies are a component of schwannomas and are usually identified in them, but they can also be seen in other neoplasms:</td>
                                  <td> <h4>Verocay bodies are seen in?</h4> </td>
                                  <td> <span className="correct">abscess</span> </td>
                                  <td>abscess</td>

                              </tr>
                              <tr>
                                  <td>5</td>
                                  <td>Title: Erythematous papule Definition: A circumscribed, solid elevation of skin with no visible fluid that is reddish (erythematous) in color.</td>
                                  <td> <h4>A 24 year old man comes with complaint of recurrent eruption on face for 6 years. On examination, there are erythematous papules and nodules involving the forehead, cheeks, nose, eyelids and ear rim. Interspersed are numerous deep pitted scars. You have decided to go ahead with a skin biopsy. What do you expect to find?</h4> </td>
                                  <td><span className="wrong">acantholytic dermatitis herpetiformis (pemphigus herpetiformis)</span> </td>
                                  <td>acantholytic dyskeratoma</td>

                              </tr>
                              <tr>
                                  <td>6</td>
                                  <td>The promontory sign is a characteristic appearance of new blood vessels wrapping around and partially entraping pre-existing blood vessels, causing the pre-existing vessels to protrude into the lumen of the new vessels. It can be seen in the following conditions:</td>
                                  <td> <h4>Promontory sign is seen in?</h4> </td>
                                  <td> <span className="correct">acantholytic dyskeratoma</span> </td>
                                  <td>acantholytic EB, lethal</td>

                              </tr>

                          </tbody>
                      </table>
                  </div> */}




              </div>
            </>
               
                  }
            </div>
          
            <Footer />
        </main>
    );
};

export default ViewResult;
